import React from "react";
import { Button, Tooltip, Typography } from "antd";
import { CompressOutlined, ExpandOutlined, InfoCircleOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const DashboardSection = ({
  id,
  icon,
  title,
  subtitle,
  helpText,
  collapsed,
  onToggle,
  action,
  children,
  collapsible = true,
  variant = "grid",
}) => (
  <section id={id} className="dash-group">
    <div
      className="dash-group__header"
      onClick={collapsible ? () => onToggle(id) : undefined}
      role={collapsible ? "button" : undefined}
      tabIndex={collapsible ? 0 : undefined}
      onKeyDown={collapsible ? (e) => e.key === "Enter" && onToggle(id) : undefined}
    >
      <div className="dash-group__heading">
        <Title level={4} className="dash-group__title">
          <span className="dash-group__title-text">
            {icon} {title}
            {helpText ? (
              <Tooltip title={helpText}>
                <InfoCircleOutlined
                  className="dash-group__title-help"
                  onClick={(e) => e.stopPropagation()}
                  aria-label={`About ${title}`}
                />
              </Tooltip>
            ) : null}
          </span>
          {collapsible ? (
            <Button
              type="text"
              icon={collapsed ? <ExpandOutlined /> : <CompressOutlined />}
              className="dash-group__toggle"
              size="small"
              tabIndex={-1}
            />
          ) : null}
        </Title>
        {subtitle ? <Text type="secondary" className="dash-group__subtitle">{subtitle}</Text> : null}
      </div>
      {action ? <div className="dash-group__action" onClick={(e) => e.stopPropagation()}>{action}</div> : null}
    </div>
    {!collapsible || !collapsed ? (
      <div className={variant === "content" ? "dash-group__body" : "dash-metric-grid"}>{children}</div>
    ) : null}
  </section>
);

export default DashboardSection;
